import { render, staticRenderFns } from "./Enquiries.vue?vue&type=template&id=563d3624&scoped=true&"
import script from "./Enquiries.vue?vue&type=script&lang=js&"
export * from "./Enquiries.vue?vue&type=script&lang=js&"
import style0 from "./Enquiries.vue?vue&type=style&index=0&id=563d3624&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d3624",
  null
  
)

export default component.exports